import { getCookie, setCookie } from 'tiny-cookie';
// Check if logging is active based on the 'logging' cookie (robust for test environments)
let loggingActive = false;
try {
    loggingActive = typeof document !== 'undefined' && typeof getCookie === 'function' && getCookie('logging') === 'true';
} catch {
    loggingActive = false;
}
export { loggingActive };
let timer: NodeJS.Timeout | null = null;

// Function to reset the timer and log a separator after inactivity
const resetTimer = () => {
    if (timer) {
        clearTimeout(timer);
    }
    timer = setTimeout(() => {
        console.log(
            '🦄 ----------------------------------------------------------------------------------',
        );
    }, 1000);
};

// Generate a random color for each scope
const scopeColors: Record<string, string> = {};
const randomColor = (): string => {
    const colors = [
        '\x1b[31m', // Red
        '\x1b[32m', // Green
        '\x1b[33m', // Yellow
        '\x1b[34m', // Blue
        '\x1b[35m', // Magenta
        '\x1b[36m', // Cyan
    ];
    return colors[Math.floor(Math.random() * colors.length)];
};

// Get a colored scope label for console output
const getColoredScope = (scope: string): string => {
    if (!scopeColors[scope]) {
        scopeColors[scope] = randomColor();
    }
    return `${scopeColors[scope]}[${scope}]\x1b[0m`;
};

// Retrieve the current log level from the cookie
export const getLogLevel = (): number => {
    return typeof document !== 'undefined' ? parseInt(getCookie('logLevel') || '0', 10) : 0;
};

export const isLogLevel = (level: number): boolean => {
    return getLogLevel() >= level;
};

export const logger = {
    // Log messages at a specified level
    log: (scope: string, level: number, ...args: unknown[]) => {
        if (!loggingActive || getLogLevel() < level) return;
        if (level >= 2) {
            scope = `${scope} (${new Date().toLocaleTimeString()})`;
        }
        console.log(getColoredScope(scope), ...args);
        resetTimer();
    },

    // Log error messages at a specified level
    error: (scope: string, level: number, ...args: unknown[]) => {
        console.error(getColoredScope(scope), ...args);
        resetTimer();
    },

    // Log warning messages at a specified level
    warn: (scope: string, level: number, ...args: unknown[]) => {
        if (!loggingActive || getLogLevel() < level) {
            return;
        }
        console.warn(getColoredScope(scope), ...args);
        resetTimer();
    },

    info: (scope: string, level: number, ...args: unknown[]) => {
        if (!loggingActive || getLogLevel() < level) {
            return;
        }
        console.info(getColoredScope(scope), ...args);
        resetTimer();
    },
};
